import React from 'react';
import { connect } from 'react-redux';
import { selectActivePrivacyStatementUrl, selectActiveTermsOfUseUrl } from '../../redux/config/selectors';
import Logo from '../../components/Logo/Logo';
import { AuthenticationLayoutStyleWrapper, LogoWrapper, Background } from './AuthenticationLayout.style';

import background from './oqio-background-2.jpg';

/**
 * Functional component for the authentication layout.
 * Provides a styled layout for authentication pages including a logo and links to legal documents.
 * @property {Object} config - configuration object containing tenant details and links to legal documents.
 * @property {React.ReactNode} children - the child components to be displayed within the layout.
 */
const AuthenticationLayoutComponent = ({ config = {}, activePrivacyStatementUrl, activeTermsOfUseUrl, children }) => {
  const { tenant_logo, tenant_name } = config;
  const imprintUrl = config?.imprint?.url;

  return (
    <AuthenticationLayoutStyleWrapper>
      <LogoWrapper>
        <Logo agencyLogo={tenant_logo?.url_small || tenant_logo?.url} agencyName={tenant_name} light />
      </LogoWrapper>
      {children}
      <div className="terms-menu">
        {imprintUrl ? (
          <a className={'oqio-link valid-link'} href={imprintUrl} target={'_blank'} rel="noopener noreferrer">
            Impressum
          </a>
        ) : (
          <span className={'oqio-link'}>Impressum</span>
        )}
        <a className={'oqio-link valid-link'} href={activeTermsOfUseUrl} target={'_blank'} rel="noopener noreferrer">
          Nutzungsbedingungen
        </a>
        <a
          className={'oqio-link valid-link'}
          href={activePrivacyStatementUrl}
          target={'_blank'}
          rel="noopener noreferrer"
        >
          Datenschutzerklärung
        </a>
      </div>
      <Background src={background} alt="risk" />
    </AuthenticationLayoutStyleWrapper>
  );
};

const mapStateToProps = (state) => ({
  activePrivacyStatementUrl: selectActivePrivacyStatementUrl(state),
  activeTermsOfUseUrl: selectActiveTermsOfUseUrl(state)
});

export const AuthenticationLayout = connect(mapStateToProps, null)(AuthenticationLayoutComponent);
